import { ModalPanelProps } from 'app/components/panels/DashboardModal';
import React, { PureComponent } from 'react';
import { Button, Radio, RadioChangeEvent, Space } from 'antd';
import { Flex } from 'app/components/common/Flex';
import Utils from 'app/common/util/Utils';
import './ApplySolutionConfirmationPanel.less';

interface ApplySolutionConfirmationPanelProps extends ModalPanelProps {
    solutions: string[];
    defaultSolution: string;
    onApplySolution: (solutionName: string) => void;
}

interface ApplySolutionConfirmationPanelState {
    checkedSolution: string;
}

export class ApplySolutionConfirmationPanel extends PureComponent<
    ApplySolutionConfirmationPanelProps,
    ApplySolutionConfirmationPanelState
> {
    state = {
        checkedSolution: this.props.defaultSolution,
    };

    private onChange = (e: RadioChangeEvent) => {
        this.setState({
            checkedSolution: e.target.value,
        });
    };

    render() {
        return (
            <Flex className="apply-solution-confirmation" direction="vertical">
                <Flex className="header" direction="vertical" size="3em">
                    <div className="title">Apply Solution</div>
                </Flex>
                <Flex className="radio-buttons">
                    <Radio.Group onChange={this.onChange} value={this.state.checkedSolution} className="radio-buttons">
                        <Space direction="vertical">
                            {this.props.solutions.map(solution => (
                                <Radio key={solution} value={solution}>
                                    {solution}
                                </Radio>
                            ))}
                        </Space>
                    </Radio.Group>
                </Flex>
                <Flex className="buttons">
                    <Button onClick={this.props.onClose}>CANCEL</Button>
                    <Button
                        onClick={() => {
                            this.props.onApplySolution(this.state.checkedSolution);
                            this.props.onClose();
                        }}
                        disabled={Utils.isNotExists(this.state.checkedSolution)}>
                        APPLY
                    </Button>
                </Flex>
            </Flex>
        );
    }
}
